import React from 'react';

const SYSTEMS = [
  {
    id: 'flyshield',
    name: 'FlyShield',
    description: 'Upload de imagens e observabilidade do detector de moscas.',
    available: true,
    color: '#0d6efd',
  },
  {
    id: 'borercontrol',
    name: 'Broca Control',
    description: 'Upload de imagens e observabilidade do detector de brocas.',
    available: true,
    color: '#6c757d',
  },
];

function HomePage({ onSelectSystem }) {
  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h1>Agroverita Observabilidade</h1>
        <p className="text-muted">Selecione o sistema que deseja acessar</p>
      </div>

      <div className="row justify-content-center g-4">
        {SYSTEMS.map((system) => (
          <div key={system.id} className="col-md-4">
            <div
              className={`card h-100 shadow-sm${system.available ? '' : ' opacity-50'}`}
              style={{ borderTop: `4px solid ${system.color}`, cursor: system.available ? 'pointer' : 'default' }}
              onClick={() => system.available && onSelectSystem(system.id)}
            >
              <div className="card-body d-flex flex-column">
                <div>
                  <h5 className="card-title" style={{ color: system.color }}>
                    {system.name}
                  </h5>
                  <p className="card-text text-muted">{system.description}</p>
                </div>
                {system.available ? (
                  <button
                    className="btn btn-sm mt-3"
                    style={{ backgroundColor: system.color, color: '#fff', border: 'none' }}
                    onClick={(e) => { e.stopPropagation(); onSelectSystem(system.id); }}
                  >
                    Acessar
                  </button>
                ) : (
                  <span className="badge bg-secondary mt-3">Em breve</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HomePage;
